$(document).ready(function(){
  window.addEventListener('resize', render, false);
  render();
  function render() {
  	var windowWidth = $( window ).width();
    if(windowWidth > 768) {
      var height = $(".sidebar--metafields").height();
      var windowHeight = $( window ).height();
      var offset =  $('.site-header').height();
      var footerHeight = $('.site-footer').height();
      $(".sidebar--metafields").sticky({topSpacing: offset, bottomSpacing: footerHeight + 80});
    }
  };
});
